import { getCurrentDomain } from '../utils/common';
export const API_VERSION = 'v1.0';
export const API_VERSION_2 = 'v2.0';
export const LOGIN_API = `Login/${API_VERSION}`;
export const CONFIGURATOR_API = `configurator/${API_VERSION}`;
export const BUSINESS_FUNCTION_API = `businessfunction/${API_VERSION}`;
export const BUSINESS_FUNCTION_API2 = `businessfunction2/${API_VERSION}`;
export const BUSINESS_FUNCTION_API_1 = `businessfunction1/${API_VERSION}`;
export const ERDATABASE_API = `ercdatabase/${API_VERSION}`;
export const DRIVE_API = `drive/${API_VERSION}`;
export const LIBRARY_API = `library/${API_VERSION}`;
export const ABAP_API = `/abap/${API_VERSION}/abap`;
export const SERVICE_API = `baas/${API_VERSION}/baas`;
export const CONFIGURATOR_V2_API = `configurator/${API_VERSION_2}`;

export const TABLE_ERC_API = `${ERDATABASE_API}/table`;
export const VIEW_ERC_API = `${ERDATABASE_API}/view`;
export const QUERY_ERC_API = `${ERDATABASE_API}/db/query`;
export const API_ERC_REQUEST = `${ERDATABASE_API}/apirequest`;
export const CREATE_ERC_API = `${TABLE_ERC_API}/create`;
export const MODIFY_ERC_API = `${TABLE_ERC_API}/modify`;
export const DRIVE_FILE_API = `${DRIVE_API}/file`;

export const API_REQUEST = `${CONFIGURATOR_API}/apirequest`;
export const CONNECTION_API = `${CONFIGURATOR_API}/connection`;
export const PLUGIN_API = `${CONFIGURATOR_API}/plugin`;
export const COMPANY_API = `${CONFIGURATOR_API}/company`;
export const AUTH_API = `${COMPANY_API}/auth`;
export const LDAP_API = `${CONFIGURATOR_API}/ldap`;
export const OAUTH_API = `${AUTH_API}/getOAuth`;

export const LOG_API = `${CONFIGURATOR_API}/log`;
export const MAIL_API = `${COMPANY_API}/mail`;
export const MASTERS_API = `${CONFIGURATOR_API}/masters`;
export const PACKAGE_API = `${CONFIGURATOR_API}/package`;
export const LICENSE_API = `${COMPANY_API}/license`;
export const PERSONALIZATION_API = `${COMPANY_API}/personalization`;
export const POLICY_API = `${CONFIGURATOR_API}/policy`;
export const SCHEDULER_API = `${CONFIGURATOR_API}/scheduler`;
export const USER_API = `${CONFIGURATOR_API}/user`;
export const BOS_API = `${CONFIGURATOR_API}/bos`;
export const PROJECT_API = `${CONFIGURATOR_API}/project`;
export const EVENT_API = `${CONFIGURATOR_API}/event`;
export const TEMPLATE_API = `${CONFIGURATOR_API}/template`;
export const ROLE_API = `${CONFIGURATOR_API}/role`;
export const USER_PROPERTIES_API = `${CONFIGURATOR_API}/userproperties`;
export const CONTAINER_APP_API = `${CONFIGURATOR_API}/container`;
export const GLOBAL_VARIABLE_API = `${COMPANY_API}/globalvariable`;
export const WORKFLOW_VARIABLE_API = `${BUSINESS_FUNCTION_API}/variable`;
export const WORKFLOW_LIST_API = `${BUSINESS_FUNCTION_API}/workflow`;
export const FUNCTION_API = `${BUSINESS_FUNCTION_API}/function`;
export const FUNCTION_API2 = `${BUSINESS_FUNCTION_API2}/function`;

export const VIEW_USER = `/viewUserProfile`;
export const CHANGE_PICTURE = `/changePicture`;
export const PICTURE = `/picture`;
export const LIST_OF_BOS = `/listofBos`;
export const LIST_OF_BOS_PROJECTS = `/listofBosProjects`;

export const PREFIX_ER_STORAGE_PLATFORM = '__er__p__';
export const PREFIX_ER_APP_STORAGE = '__er__a__';
export const PREFIX_ER_LOGIN_STORAGE = '__er__l__';
export const ENVIRONMENT_KEY = `env`;
export const DOUBLE_SIDE_ARROW =
  'edgeStyle=orthogonalEdgeStyle;movable=0;orthogonalLoop=1;endArrow=classic;startArrow=classic;html=1;'; //exitX=0.25;exitY=1;exitDx=0;exitDy=0;entryX=0;entryY=0.25;entryDx=0;entryDy=0;
export const OFFLINE_APP_ARROW =
  'edgeStyle=orthogonalEdgeStyle;movable=0;orthogonalLoop=1;html=1;'; //exitX=0.50;exitY=1;exitDx=0;exitDy=0;entryX=0;entryY=0.25;entryDx=0;entryDy=0;

export const SELECTED_EDGE_STYLE =
  'edgeStyle=orthogonalEdgeStyle;html=1;strokeColor=#0000FF'; //exitX=1;exitY=0.5;exitDx=0;exitDy=0;
export const DEFAULT_EDGE_STYLE =
  'edgeStyle=orthogonalEdgeStyle;orthogonalLoop=1;jettySize=auto;html=1;movable=0;rounded=0;'; //exitX=1;exitY=0.5;exitDx=0;exitDy=0;

export const LOGINMICROAPP = "LoginMicroApp";

export const USERPILOT_RC_TOKEN = "Sr3G26T";
export const DOCU360_DOMAIN = 'https://apihub.document360.io';
export const DOCU360_PROJECT_ID = 'b68288c6-703e-48cd-b4c1-c6867d91a064';
export const DOCU360_API_TOKEN = '6u5guwqLsbNPn8cqFNzEjg69By85f08mYh4tyQedP+drWVdwfPvZviilU4Hrsny0MpR9ZPt5C++kMO6Ub/xmD8tq1n/CIBEJz9O4j9RgTs9IRej8N/enpxScI2UKLe/qKXsp0fRG15aPuP6UHilVHQ==';

export const pillirConstants = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  csvFileFormatMsg: 'Please select .csv file format only',
  sessionExpired: 'Session Expired ! Please Login again',
  noRecords: 'No Records available',
};

export const allItemsConstants = {
  pageTitle: 'All Items',
  pageSubTitle: 'Workflow Administration',
};

export const libraryConstants = {
  // managePermission: "Manage permissions",
  // dbTitle: 'Database Tables',
  // driveTitle: "Drive",
  // schdTitle: "'BOS Scheduler",
  // newSchd: "New Schedule"
};

export const projectDetailsConstants = {
  // projectAction: {
  //   share: 'Share Project',
  //   delete: 'Delete Project'
  // },
  // noRolesAssigned: 'No apps assigned',
  // roleVersionText: 'Version {version}',
  // defaultVersion: '1.0 unpublished',
  // managePermission: "Manage project permissions",
  // delProject: 'Delete Project',
  // delProjSub1: `Are you sure to delete the `,
  // delProjSub2: `? Once deleted you may able to retrieve within next 24 hours`,
  // projTitle: "EdgeReady Applications",
};

export const loginConstants = {
  URL_PREFIX: '__er__l__',
  // loginFormHeader: 'Welcome back to Pillir',
  // loginFormSubHeader: 'Ready to transform your business?',
  // userNameRequired: 'Username is required field',
  // passwordRequired: 'Password is required field',
  // currentPasswordRequired: 'Current Password is required field',
  // titleRequired: 'Company title is required field',
  // emailRequired: 'Email address is required field',
  // emailInvalid: 'Email address is invalid',
  // lastNameRequired: 'Last Name is required field',
  // firstNameRequired: 'First Name is required field',
  // tenantIdRequired: 'Tenant ID is required field',
  // newPasswordRequired: 'New Password is required field',
  // passwordPolicyTitle: 'Password Policy',
  // passwordPolicySubTitle: 'Your password must have:',
  // lowerCaseLetter: 'At least 1 lowercase alphabet',
  // upperCaseLetter: 'At least 1 uppercase alphabet',
  // numericLetter: 'At least 1 numeric character',
  // specialCharacters: 'At least 1 special character',
  invalidPassword: 'Invalid Password',
  invalidUserId: 'Invalid UserId',
  pwdExpired: 'Your password will expire soon.',
  // serverError: 'Internal server error. Please try again later',
  newPasswordPolicyError:
    'New password is not fulfilling with the password policy',
  // newConfirmNotMatching: 'Confirm password not match with new password',
  // noPrevPassword:
  //   'The current password and new password should not be the same',
  matchingPreviousPassword:
    'Password should not be one of your last 3 passwords',
  invalidUsernameTenantId: 'Invalid UserId or TenantId',
  // title: 'Title',
  // firstName: 'First name',
  // lastName: 'Last name',
  // email: 'Business e-mail',
  // companyTitle: 'Company title',
  // language: 'Language',
  // timezone: 'Timezone',
  // dateFormat: 'Date format',
  // dropAFile: 'Drop a file here',
  // or: 'or',
  // selectAFile: 'Select a file',
  // jpgAPng: '.jpg or .png files only',
  // removePhoto: 'Remove profile photo',
  // profile: 'Profile',
  // passwordExpiry: 'Password Expiry',
  // personalInformationTitle: 'Personal information',
  // businessInformationTitle: 'Business information',
  // accountInformationTitle: 'Account information',
  // pwdExpError: 'Password expired',
  // usrLockError: 'User Locked',
  // accountSettings: 'Account settings',
  // imageFileFormatMsg: 'Please choose PNG’s or JPEG’s file formats',
  // fileSizeMsg: 'Image file should not exceed 1 MB.',
  // resetPasswordTitle: 'Reset your password',
  // resetPasswordDesc:
  //   'Just enter your details and we’ll reset your account for you. If you can’t remember them, get in touch.',
  // checkMailTxtTitle: 'Check your email',
  // checkMailTxtDesc: 'Your password has been reset.\nWe sent you an email.',
  checkMailTxtDesc2:
    'We sent you an email with instructions that should be with you in a few minutes.',
  // changePasswordTitle: 'Change your password',
  // characters: 'characters',
  // minimumLength: 'Minimum length of',
  // userName: 'Username',
  // password: 'Password',
  // currentPassword: 'Current Password',
  // newPassword: 'New Password',
  // confirmPassword: 'Confirm Password',
  // changePassword: 'Change password',
  // tenantId: 'Tenant ID',
  // environment: 'Environment',
  // environments: [
  //   { id: 'dev', value: 'Development' },
  //   { id: 'qua', value: 'Quality' },
  //   { id: 'prod', value: 'Production' },
  // ],
  // forgotPassword: 'Forgot password?',
  // signIn: 'Sign in',
  // cancel: 'Cancel',
  // update: 'Update',
  resetPassword: 'Reset password',
  // bannerText: 'Did you know...',
  // slides: [
  //   {
  //     text:
  //       '...you can create multiple lanes on a process? Just drag a new lane from the toolbox and give it a name.',
  //   },
  //   {
  //     text: 'it reduce coding work',
  //   },
  //   {
  //     text: 'you can develop & deploy application quickly',
  //   },
  // ]
};

export const allProjectConstants = {
  // alertNoRecAvail: "No Records available",
  // menuRecentDel: "Recently Deleted",
  // menuActive: "Active",
  // menuAll: "All",
  // title: "New Project",
};

/* Drive module */
export const driveConstants = {
  // newFolderValidationMsg: 'Please enter folder name',
  // movePathValidationMsg: 'Unable to move folder to the same path',
  moveSelectFolderMsg: 'Please select folder to move',
  copyPathValidationMsg: 'Unable to copy folder to the same path',
  // folderExistsMsg: 'Folder name already exists',
  // copySelectFolderMsg: 'Please select folder to copy',
  // newFolderSplCharMsg:
  //   'Folder name can\'t contain any of the following characters: /:*?"<>|',

  // drvFiles: "Files",
  // drvLibraryFiles:  "Library Files",
  // drvUploadFile: "Upload file",
  // drvNewFolder: "New Folder",
  // drvLibrary: 'Library',
  // drvDrive: 'Drive',

  // updTitle: "Upload file",

  // nfCreate: "Create",
  // nfCancel: "Cancel",
  // nfLibraryAccess: "This folder becomes available to anyone with Library access",
  // nfAccessFolder: "Everyone on this project can access this folder",
  nfAccessLevel: 'Access level',
  // nfName: "Name",
  // nfFolderName: "Folder Name",
  // nfNewFolder: "New Folder",

  // rfStorage: "Storage",
  // rfRecentFiles: "Recent Files",
  // rfOf: "of",
  // rfUsed: "used"
};

export const regularExpConstants = {
  csvFileExp: '(.*?).(csv|CSV)$',
  imgFileExp: '(.*?).(jpe?g|png|JPE?G|PNG)$',
  folderNameExp: '/[\\/:*?"<>|]/',
  emailEXp: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
  domainExp:
    /^[a-z0-9\*]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
  urlExp:
    /^(http|https):\/\/[a-z0-9\*]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
  packageNameExp: /^(com)((\.[a-z0-9_]+){1})(\.[a-z0-9A-Z_]+)+[0-9a-zA-Z_]$/,
  versionNumberExp: /^\d+(\.\d+){0,}$/,
  ALPHA_NUMNERIC_PATTERN: /^[0-9a-zA-Z_ ]*$/,
  NUMERIC_PATTERN: /^[0-9]*$/,
};

export const fileUploadExtension = {
  imgFileExp: 'image/*',
  ".png/.svg/.jpg": 'image/*',
  "image/*": 'image/*',
  ".css":'.css', //'text/css',
  ".mp3":'.mp3', //'audio/*',
  ".js":'.js', //'text/javascript',
  ".jar":'.jar' //'application/java-archive'
};

export const userRolesConstants = {
  noPermission:
    "It seems you don't have permission to view the requested page. Please contact your administrator.",
};

/*Database Module*/
export const databaseValidation = {
  // tableCreateInvalidMsg:
  // 'Table name should contains atleast 1 alphabet letter or _',
  // tableCreateEnterMsg: 'Enter the Table Name',
};

/* scheduler module*/
export const schedulerConstants = {
  // timeBasedScheduleTitle: 'Time-based schedule',
  // eventBasedScheduleTitle: 'Event-based schedule',
  // triggerActionTitle: 'How do you want to trigger your action?',
  // selectBosTitle: 'Select a BOS to invoke',
  // parameterScheduleTitle: 'Do you want to define any parameters?',
  // whenScheduleTitle: 'When do you want to trigger it?',
  // whichEventTitle: 'Which event do you want to trigger it?',
  // finalConfirmTitle: 'Final step,confirm your schedule',
  nameValidationMsg: 'Please enter schedule name',
  // basedOnTime: 'Based on time',
  // basedOnEvent: 'Based on an event',
  // periodicallyInvoking: 'Want to invoke something periodically?',
  // eventInvoking: 'Want to invoke something if an event happens?',
  // startHere: 'Start here',
  // projectSelectValidationMsg: 'Please select a project',
  // bosSelectValidationMsg: 'Please select a bos',
  serviceTypeValidationMsg: 'Please select service type',
  selectEventValidationMsg: 'Please select event',
  // triggerValidationMsg: 'Please enter scheduler value',
  // triggerHrValidationMsg: 'Please enter hour value',
  // triggerMinValidationMsg: 'Please enter minutes value',
  // triggerTimeValidationMsg: 'Please enter hours and minutes value',
  nameSplCharValidationMsg: 'Please enter valid name',
  // nameSchedule: 'Name your schedule',
  // toDO: 'To do',
  descriptionOptional: 'Description (optional)',
  // serviceTypeInvoke: 'What do you want to invoke?',
  // serviceTypes: ['BOS'],
  // event: 'Event',
  // selectEvent: 'Select event',
  // parameterValues: {
  //   variables: [{ variables: 'X', dataType: 'Y', value: 'Z' }],
  //   system: [{ system: 'X', userId: 'Y', userId: 'Z' }],
  // },
  // selectProject: 'Select project',
  // selectBos: 'Select bos',
  // repeatEvery: 'Repeat every',
  // addAnotherTrigger: 'Add another trigger',
  // at: 'at',
  // on: 'on',
  // onThe: 'on the',
  // loginIdSelection: 'Do you want to run as a specific user? (optional)',
  // loginId: 'Login ID',
  // name: 'Name',
  // description: 'Description',
  // parameters: 'Parameters',
  // type: 'Type',
  // bos: 'BOS',
  // selectServiceType: 'Select service type',
  // backBtn: 'Back',
  // nextBtn: 'Next',
  // saveBtn: 'Save',
  // cancelBtn: 'Cancel',
  // saveDraft: 'Save draft',
  // saveWithoutEnable: 'Save without enabling',
  // createScheduleButton: 'Create and enable schedule',
  // editScheduleTitle: 'Edit Schedule',
  // saveEnableScheduleButton: 'Save and enable schedule',
  // noRecords: 'No data Available',
};

/* Admin Module */
export const adminConstants = {
  // logsErrorNoLogs: "No logs available",
  // ADMIN_TOOLS: 'Admin Tools',
  // authUpdate: "Update",
  // authCancel: "Cancel",
  // authOpMap: "Output Mapping",
  // authIpMap: "Input Mapping",
  // authCustomAuth: "Custom Authentication",
  // authBos: "BOS",
  // authNoRecError: 'No records available',
  // /* Connectivity */
  // ALPHA_NUMNERIC_PATTERN: /^[0-9a-zA-Z_ ]*$/,
  // NUMERIC_PATTERN: /^[0-9]*$/,
  // settings: 'Settings',
  // authentication_type: 'Authentication Type',
  // url: 'URL',
  // cancel: 'Cancel',
  // save: 'Save',
  /* Connection Manager */
  /* Mail Config */
  /* Logs */
  // LOGS_CALL_FREQUENCY: 40,
  // uuid: 'UUID',
  // timestamp: 'Time Stamp',
  // logtype: 'Log Type',
  // apitype: 'API Type',
  // deviceType: 'Device Type',
  // userAgent: 'User Agent',
  // ipAddress: 'IP Address',
  // method: 'Method',
  // data: 'Data',
  // message: 'Message',
  // loginName: 'Login Name',
  // tenant: 'Tenant',
};

export const integrationBuilderConstants = {
  // variableExistMsg: 'Variable Name already exist',
  // newVariableValidationMsg: 'Please enter name value',
  // addBtn: 'Ok',
  // updateBtn: 'Save',
  // cancelBtn: 'Cancel',
  // newVariableTitle: 'Add Variable',
  // editVariableTitle: 'Edit Variable',
  // ObjkeyErrorMsg: 'Please enter key',
  // ObjValueErrorMsg: 'Please enter type',
  // variableDataTypes: ['String', 'Number', 'Date', 'Decimal'],
  // ObjDuplicateKeyErrorMsg: 'Key already exists.',
  // reservedValue: 'Project Name starts with $ _ - is not allowed',
};

export const businessFunctionTransportConstants = {
  // transTableHeaderOne: "Transporting ",
  // transportSubTitle:
  //   'Transporting a version will package all the required objects for an app and move it to Quality environment',
  // transTableHeaderTwo: " to Quality",
  // transLoadTitle: "Transporting the application",
  // transportComplete: "Transport Complete",
  // transportFailed: "Transport Failed",
  // transSuccessfullyTransported: "Successfully Transported",
  // transportFailedSubTitle: "Your transport failed. Check the error log below for the reason",
  // transportSuccessSubTitle: "Your transport succeeded. Check the log below for the reason",
  // qaAcceptTableHeaderOne: "Transporting ",
  // qaAcceptTableHeaderTwo: " to Quality",
  // prodAcceptTableHeaderOne: "Transporting ",
  // prodAcceptTableHeaderTwo: " to Quality",
  // acceptLoadTitle: "Applying...",
  // acceptComplete: "Transport Complete",
  // acceptFailed: "Transport Failed",
  // acceptSuccessfullyTransported: "Successfully Transported",
  // acceptFailedSubTitle: "Your transport failed. Check the error log below for the reason",
  // acceptSuccessSubTitle: "Your transport succeeded. Check the log below for the reason",
  // qaApproveTableHeaderOne: "Transporting ",
  // qaApproveTableHeaderTwo: " to Production",
  // prodApproveTableHeaderOne: "Transporting ",
  // prodApproveTableHeaderTwo: " to Quality",
  // approveLoadTitle: "Approving...",
  // approveComplete: "Transport Complete",
  // approveFailed: "Transport Failed",
  // approveSuccessfullyTransported: "Successfully Transported",
  // approveFailedSubTitle: "Your transport failed. Check the error log below for the reason",
  // approveSuccessSubTitle: "Your transport succeeded. Check the log below for the reason",
  // qaRejectTableHeaderOne: "Transporting ",
  // qaRejectTableHeaderTwo: " to Quality",
  // prodRejectTableHeaderOne: "Transporting ",
  // prodRejectTableHeaderTwo: " to Quality",
  // rejectLoadTitle: "Rejecting...",
  // rejectComplete: "Transport Complete",
  // rejectFailed: "Transport Failed",
  // rejectSuccessfullyTransported: "Successfully Transported",
  // rejectFailedSubTitle: "Your transport failed. Check the error log below for the reason",
  // rejectSuccessSubTitle: "Your transport succeeded. Check the log below for the reason",
  // //  secondPageTitleDev: "Bundling the packages",
  // stepOneText: "Packaging the application",
  // stepTwoText: "Applying roles",
  // stepThreeText: "Applying required tables",
  // stepFourText: "Applying configurations",
  // stepFiveText: "Applying application bundle",
  // stepSixText: "Done",
  // transportTableColumns: [
  //   {
  //     id: '',
  //     label: '',
  //     align: 'center',
  //     type: 'radio',
  //     disabled: true,
  //     specifyHide: true,
  //     style: {
  //       marginLeft: 8,
  //       minWidth: '24px',
  //       maxWidth: '24px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //       paddingLeft: '8px',
  //     },
  //   },
  //   {
  //     id: 'version',
  //     label: 'Version',
  //     align: 'left',
  //     type: 'text',
  //     disabled: false,
  //     specifyHide: true,
  //     style: {
  //       marginLeft: 24,
  //       minWidth: '104px',
  //       maxWidth: '104px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //       paddingLeft: '8px',
  //     },
  //     rowStyle: {
  //       fontWeight: "500",
  //       fontSize: "13px",
  //       color: "rgba(0, 0, 0, 0.5)",
  //       marginLeft: 24,
  //       minWidth: '104px',
  //       maxWidth: '104px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //       paddingLeft: '8px',
  //     }
  //   },
  //   {
  //     id: 'createdTimestamp',
  //     label: 'Published On',
  //     align: 'left',
  //     type: 'text',
  //     disabled: true,
  //     specifyHide: true,
  //     style: {
  //       marginLeft: 24,
  //       minWidth: '192px',
  //       maxWidth: '192px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //       paddingLeft: '8px',
  //     },
  //     rowStyle: {
  //       fontWeight: "500",
  //       fontSize: "13px",
  //       color: "rgba(0, 0, 0, 0.5)",
  //       marginLeft: 24,
  //       minWidth: '192px',
  //       maxWidth: '192px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //       paddingLeft: '8px',
  //     }
  //   },
  //   {
  //     id: 'comment',
  //     label: 'Notes',
  //     align: 'left',
  //     type: 'text',
  //     disabled: false,
  //     specifyHide: true,
  //     style: {
  //       marginLeft: 24,
  //       minWidth: '245px',
  //       maxWidth: '245px',
  //       overflowWrap: 'break-word',
  //       padding: '8px',
  //     },
  //     rowStyle: {
  //       fontWeight: "500",
  //       fontSize: "13px",
  //       color: "rgba(0, 0, 0, 0.5)",
  //       marginLeft: 24,
  //       minWidth: '245px',
  //       maxWidth: '245px',
  //       overflowWrap: 'break-word',
  //       padding: '8px',
  //     }
  //   }
  // ],
  // commentRequired: 'Should not be empty',
  // notPublished: 'Not Published',
  // notes: "Notes",
  // notesPlaceholder: "Add any additional transport comments here",
  // transportBtn: "Transport",
  // cancelBtn: "Cancel",
  // backBtn: "Back",
  // nextBtn: "Next",
  // errorLogPlaceholder: "Complete Error log here..",
  // logPlaceholder: "Complete log here..",
  // acceptModalSubTitle: `Accepting this version will overwrite the previous active version`,
  // approveModalSubTitle: "Approving will move this active version to Production.",
  // rejectModalSubTitle: `Rejecting will roll-back quality to the previous active version`,
  // acceptModalTitle: "Accept the transport",
  // approveModalTitle: "Approve to Transport",
  // rejectModalTitle: "Reject the transport",
  // rejectConfirmTitle: "Rejected",
  // acceptTitleForProd: "Do you want to make this the active version in PROD?",
};
export const businessFunctionVariableConstants = {
  // confirmUpdateMessage:
  // 'After Update Variable , You need to manually update variable in the Components in which the variable is used. Do you wish to update the variable ?',
  // confirmDeleteMessage: 'Do you want to delete this variable?',
  // confirmUpdateTitle: 'Warning',
  // confirmDeleteTitle: 'Are you sure ?',
};

export const businessProcessConstants = {
  // clearActionText: 'Clear'
  // stepOneText: 'Packaging the application',
  // stepTwoText: 'Applying roles',
  // stepThreeText: 'Applying required tables',
  // stepFourText: 'Applying configurations',
  // stepFiveText: 'Applying application bundle',
  // stepSixText: 'Done',
  // clearActionText: 'Clear',
  // breadCrumbTitle: 'Process',
  // transportTableColumns: [
  //   {
  //     id: '',
  //     label: '',
  //     align: 'center',
  //     type: 'radio',
  //     disabled: true,
  //     specifyHide: true,
  //     style: {
  //       marginLeft: 8,
  //       minWidth: '24px',
  //       maxWidth: '24px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //       paddingLeft: '8px',
  //     },
  //   },
  //   {
  //     id: 'version',
  //     label: 'Version',
  //     align: 'left',
  //     type: 'text',
  //     disabled: false,
  //     specifyHide: true,
  //     style: {
  //       marginLeft: 24,
  //       minWidth: '104px',
  //       maxWidth: '104px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //       paddingLeft: '8px',
  //     },
  //     rowStyle: {
  //       fontWeight: '500',
  //       fontSize: '13px',
  //       color: 'rgba(0, 0, 0, 0.5)',
  //       marginLeft: 24,
  //       minWidth: '104px',
  //       maxWidth: '104px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //       paddingLeft: '8px',
  //     },
  //   },
  //   {
  //     id: 'createdTimestamp',
  //     label: 'Published On',
  //     align: 'left',
  //     type: 'text',
  //     disabled: true,
  //     specifyHide: true,
  //     style: {
  //       marginLeft: 24,
  //       minWidth: '192px',
  //       maxWidth: '192px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //       paddingLeft: '8px',
  //     },
  //     rowStyle: {
  //       fontWeight: '500',
  //       fontSize: '13px',
  //       color: 'rgba(0, 0, 0, 0.5)',
  //       marginLeft: 24,
  //       minWidth: '192px',
  //       maxWidth: '192px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //       paddingLeft: '8px',
  //     },
  //   },
  //   {
  //     id: 'comment',
  //     label: 'Notes',
  //     align: 'left',
  //     type: 'text',
  //     disabled: false,
  //     specifyHide: true,
  //     style: {
  //       marginLeft: 24,
  //       minWidth: '245px',
  //       maxWidth: '245px',
  //       overflowWrap: 'break-word',
  //       padding: '8px',
  //     },
  //     rowStyle: {
  //       fontWeight: '500',
  //       fontSize: '13px',
  //       color: 'rgba(0, 0, 0, 0.5)',
  //       marginLeft: 24,
  //       minWidth: '245px',
  //       maxWidth: '245px',
  //       overflowWrap: 'break-word',
  //       padding: '8px',
  //     },
  //   },
  // ],
  // commentRequired: 'Should not be empty',
  // notPublished: 'Not Published',
  // notes: 'Notes',
  // notesPlaceholder: 'Add any additional transport comments here',
  // transportBtn: 'Transport',
  // cancelBtn: 'Cancel',
  // backBtn: 'Back',
  // nextBtn: 'Next',
  // errorLogPlaceholder: 'Complete Error log here..',
  // logPlaceholder: 'Complete log here..',
  // acceptModalSubTitle: `Accepting this version will overwrite the previous active version`,
  // approveModalSubTitle:
  //   'Approving will move this active version to Production.',
  // rejectModalSubTitle: `Rejecting will roll-back quality to the previous active version`,
  // acceptModalTitle: 'Accept the transport',
  // approveModalTitle: 'Approve to Transport',
  // rejectModalTitle: 'Reject the transport',
  // rejectConfirmTitle: 'Reject Complete',
  // acceptTitleForProd: 'Do you want to make this the active version in PROD?',
};
// export const businessFunctionVariableConstants = {
//   confirmUpdateMessage:
//     'After Update Variable , You need to manually update variable in the Components in which the variable is used. Do you wish to update the variable ?',
//   confirmDeleteMessage:
//     'After delete Variable , You need to manually delete variable in the Components in which the variable is used. Do you want to delete this variable?',
//   confirmUpdateTitle: 'Warning',
//   confirmDeleteTitle: 'Are you sure ?',
// };

export const businessFunctionPublishConstants = {
  // viewLogs: 'View Logs',
  // confirm: 'Are you sure?',
  // cancelBtn: 'Cancel',
  // backBtn: 'Back',
  // nextBtn: 'Next',
  // publishBtn: 'Publish',
  // previewBtn: 'Preview',
  // previewTitle: 'Deployment platform',
  // previewSubTitle: 'Select your deployment platform to preview',
  // previewFailedTitle: 'Preview generation failed',
  // previewFailedSubTitle:
  //   'Generating preview failed. check error logs below for the reason',
  // selectPlatform: 'Select the deployment platform',
  // selectModeTitle: 'Select the mode of preview',
  // selectPreviewMode: 'Select the preview mode',
  // selectMode: 'Device Preview',
  // inBrowser: 'In Browser',
  // inDevice: 'In Device',
  // notPublished: 'Not Published',
  // timeTakes: 'This only takes few secs...',
  // generatingTitle: 'Generating preview for',
  // generatingTxt:
  //   'Go to the EdgeReady Preview app to continue. Don’t have the app yet? Download it from here.',
  // otaIosUrl: 'Copy iOS OTA URL',
  // otaAndroidUrl: 'Copy Android OTA URL',
  // ipaOtaUrl: `${getCurrentDomain()}/${sessionStorage.getItem('env')}/previewapp/index.html`,
  // apkOtaUrl: `${getCurrentDomain()}/${sessionStorage.getItem('env')}/previewapp/index.html`,
  // previewQR: `/previewapp/qrcode.png`,
  // title: 'Do you want to publish your apps?',
  // subTitle:
  //   'Publishing commits your development and makes your applications available to users',
  // secondPageTitle: 'Additional information for your app',
  // secondPageSubTitle:
  //   'Publishing an app builds a release version of your application and allows you to choose a deployment platform for your users',
  // thirdPageTitle: 'Publishing...',
  // fourthPageTitle: 'Your app has been published',
  // app: 'App',
  // appSubtitle: 'has been published as a',
  // downloadHybrid: 'Download the hybrid container from the ota url',
  // selectThePlatform: 'Select the deployment platform',
  // initializingPublish: 'Initializing the publish',
  // gatheringInformation: 'Gathering app information',
  // generatingCode: 'Generating the Code',
  // done: 'Done',
  // previewGenerated: 'Preview generated for ',
  // downloadOta: 'Download the hybrid container from the ota url',
  // downloadContainer: 'Download the container app from using your ota url',
  // downloadCollaborator: 'Download the app from our ota url, using the barcode',
  // proPublish: 'Under project you should see the app to be previewed',
  // signInEdgeReady: 'Sign in with your EdgeReady credentials',
  // youWouldFind: 'You would find the',
  // inTheApps: 'in Apps section',
  // inthePreview: 'in the project section',
  // openAppTap: 'Open the app on tapping on it',
  // useEdgeReady: 'Use EdgeReady Web App link given below',
  // body: "This marks this commit as complete and notifies this project's owner, so they can review it.",
  // versionFormat: 'should be 1 and above in the format. Ex: 1.0',
  // appTypeRequired: 'Select any one Application type',
  // comments: 'Comments',
  // commentRequired: 'Should not be empty',
  // versionNumber: 'Version Number',
  // publishSuccess: 'Published Successfully',
  // publishFailed: 'Publish failed',
  // failedMessage: 'Generating Preview failed',
  // initializingPublish: 'Initializing the publish',
  // gatherApp: 'Gathering app informations',
  // generatingCode: 'Generating code',
  // publishTableColumns: [
  //   {
  //     id: '',
  //     label: '',
  //     align: 'center',
  //     type: 'radio',
  //     disabled: true,
  //     style: {
  //       marginLeft: 8,
  //       minWidth: '24px',
  //       maxWidth: '24px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //       paddingLeft: '8px',
  //     },
  //   },
  //   {
  //     id: 'roleName',
  //     label: 'Role name',
  //     align: 'left',
  //     type: 'text',
  //     disabled: true,
  //     style: {
  //       marginLeft: 24,
  //       minWidth: '100px',
  //       maxWidth: '100px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //       paddingLeft: '8px',
  //     },
  //   },
  //   {
  //     id: 'appName',
  //     label: 'App name',
  //     align: 'left',
  //     type: 'text',
  //     disabled: true,
  //     style: {
  //       marginLeft: 24,
  //       minWidth: '100px',
  //       maxWidth: '100px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //       paddingLeft: '8px',
  //     },
  //   },
  //   {
  //     id: 'publishedVersion',
  //     label: 'Last Published Version',
  //     align: 'left',
  //     type: 'text',
  //     disabled: true,
  //     style: {
  //       marginLeft: 24,
  //       minWidth: '100px',
  //       maxWidth: '100px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //       paddingLeft: '8px',
  //     },
  //   },
  //   {
  //     id: 'publishedBy',
  //     label: 'Last Published By',
  //     align: 'left',
  //     type: 'text',
  //     disabled: true,
  //     style: {
  //       marginLeft: 24,
  //       minWidth: '100px',
  //       maxWidth: '100px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //       paddingLeft: '8px',
  //     },
  //   },
  //   {
  //     id: 'publishedOn',
  //     label: 'Last Published On',
  //     align: 'left',
  //     type: 'text',
  //     disabled: true,
  //     style: {
  //       marginLeft: 24,
  //       minWidth: '150px',
  //       maxWidth: '150px',
  //       overflowWrap: 'break-word',
  //       padding: '8px',
  //     },
  //   },
  // ],
};

export const addNewRoleConstants = {
  // title: 'Tell us more about this role',
  // subTitle:
  // 'A role defines the responsibilities and job descriptions of people executing this business function.',
};

export const appDetailsConstants = {
  // firstScreen: {
  //   title: 'Lets capture some details for this app',
  //   subTitle:
  //     'The combination of the business function - {businessFunction} and the role - {roleName} constitutes an app.',
  // },
  // secondScreen: {
  //   title: 'Would you like to build workflow apps?',
  //   desc:
  //     'A workflow consists of an orchestrated and repeatable pattern of activities and tasks performed by various people and systems to execute a business function or a business process. A workflow app manages these activities and tasks such as automatic routing and automated processes between systems and people in various roles. Simple examples are Purchase order approvals, Expense approvals, Time capture, etc.',
  // },
  // thirdScreen: {
  //   onlineDesc:
  //     'Online apps need constant network availability and work on all browsers and mobile devices. Easy to deploy and rollout. Excellent when internet connectivity is not a problem for end-users.',
  //   offlineDesc:
  //     'Offline apps work without any dependency on network availability and only work on mobile devices. They operate in offline mode when internet connectivity is not available and automatically switch to online mode when internet connectivity is established. Excellent for remote location usage where internet connectivity is a problem.',
  //   offlineDisabled:
  //     'Workflow apps are not supported in offline mode in this release.',
  // },
  // fourthScreen: {
  //   title: 'Primary deployment platform',
  //   subTitle:
  //     'An app can be deployed on all platforms simultaneously but choosing a particular deployment platform will help you design the app even better for the preferred device of choice by end-users',
  //   webDesc: 'Great choice when web is the only interface for your users.',
  //   mobileDesc:
  //     'Apps with a consistent look-n-feel across all mobile devices and web browsers.',
  // },
  // iconScreen: {
  //   title: 'Additional Details for your {appName} app',
  //   fields: {
  //     menu: {
  //       label: 'Does this app have menu ? (Coming Soon)',
  //       options: {
  //         yes: 'Yes',
  //         no: 'No',
  //       },
  //     },
  //     build: {
  //       label: 'Select or build an icon for the app',
  //     },
  //   },
  // },
};

export const newBusinessFunctionConstants = {
  // firstScreen: {
  //   title: 'What’s your function about?',
  //   subTitle:
  //     'A business function consists of structured activities executed in a predetermined sequence by people (or systems) in their given roles. A combination of a business function and a role constitutes an application.',
  // },
  // secondScreen: {
  //   title: 'How do you want to start?',
  //   firstSubTitle: 'From Scratch',
  //   firstMessage:
  //     'For the innovators. Start from scratch and start inventing the future of your business.',
  //   firstBtn: 'Start from scratch',
  //   secondSubTitle: 'From SAP Abap Program',
  //   secondMessage:
  //     'Leverage your investments in SAP. Modernize your ABAP customizations into cloud-native apps.',
  //   secondBtn: 'Start to Modernize',
  // },
  // newFunctionBtn: 'Business function',
  // title: 'Build your first business function',
  // newFuncTitle: "Creating Business Function...",
  // pickTemp: "Pick a template",
  // editSettings: "Edit your function settings",
  // nextBtn: "Next",
  // backBtn: "Back",
  // description: "Description",
  // name: "Name",
  // errorEnterVal: "Please enter the value",
  // errorFuncName: "Please enter Function Name",
  // errorDescValue: "Please enter Description Value",
  // errorAlphaNumberic: "Only alphanumeric character are allowed",
  // newBFMessage: 'A business function consists of structured activities executed in a predetermined sequence by people (or systems) in their given roles. A combination of a business function and a role constitutes an application.',
};

export const businessFunctionPreviewConstants = {
  // previewTitle: 'Generating for Preview...',
  // failedMessage: 'Generating Preview failed',
};

export const businessFunctionRevertConstants = {
  // title: 'Do you want to revert the changes?',
  // progressTitle: 'Reverting ...',
  // subTitle: 'Choose the right version to revert. By reverting the existing changes will be gone.',
  // confirmBtn: 'Revert',
  // revertFailedTitle: 'Revert failed',
  // revertFailedSubTitle: 'check error logs below for the reason',
};

export const businessFunctionAppPreviewConstants = {
  title: 'Test your app with the Workflow',
  subTitle:
    'In order to test the non start lane, use the respective state data',
};

export const dashboardConstants = {
  // pillirSupport: 'Pillir Support',
  // supportURL: 'https://appsfreedom.atlassian.net/servicedesk/customer/portals',
  // supportMail: 'support@pillir.io',
  // infoProjectAlert: 'Maximum 3 projects can be opened at a time. Please close the opened projects and try again.',
};

export const tenantCreationConstants = {
  // enterValue: 'Please Enter ',
  // specialCharRestrict: 'Special Characters are restricted',
  // numberOnly: 'Only numeric values are allowed',
};

export const newProjectConstants = {
  // subTitle:
  //   'A project is a workspace to manage all development objects related to building an app',
  // errorAlreadyExist: "Project Name already exists",
  // errorDesc: "Please enter the Description",
  // errorProjectName: "Please enter the Project Name",
  // textName: "Name",
  // textDec: "Description",
  // fromTemp: "From a template",
  // startTemp: "Start from template",
  // fromSratch: "From scratch",
  // startSratch: "Start from scratch",
  // exToCan: "From Excel or GoCanvas",
  // importFile: "Import a file",
  // roles: "Roles",
  // functions: "Functions",
  // Cancel: "Cancel",
  // Next: "Next",
  // Back: "Back",
  // Title1: "Tell us more about your project",
  // creatingProject: "Creating Project..",
  // Title2: "How do you want to start?",
  // pickTemp: "Pick a template",
  // projManager: "Project Manager",
  // manageTasks: "Manage tasks, resource and calendars",
  // byPillir: "by Pillir",
  // startTempDesc: "Start from dozens of high-quality templates and to from 0 to hero",
  // limitsDesc: "Want to push EdgeReady to its limits? This is the mode for you.",
  // alreadyExistingDesc: "Want to import an already existing app? Use our import tools to start"
};

export const projectFileConstants = {
  // modernizer: "Modernizing...",
  // newCommit: "New Commit",
  // BusinessProcess: " Business Process",
  // edited: 'Edited ',
  // secAgo: "few seconds ago",
  // minAgo: ' minutes ago',
  // hoursAgo: ' hours ago',
  // daysAgo: ' days ago',
  // monthsAgo: ' months ago',
  // yearsAgo: ' years ago'
};

const staticStyle = {
  // marginLeft: 24,
  // overflowWrap: 'break-word',
  // paddingTop: '5px',
  // paddingBottom: '5px',
};

export const containerAppConstants = {
  // name: 'Name',
  // nameText: 'Please enter application name',
  // devices: 'Please select atleast one device',
  // permissionText: 'Please enter the description',
  // SuccessfullyInitiated: 'Successfully Initiated',
  // noBuilds: 'No App Builds Exist',
  // enterprise: 'enterprise',
  // pwa: 'pwa',
  // hybrid: 'hybrid',
  // native: 'native',
  // ios: 'iOS',
  // android: 'Android',
  // windows: 'Windows',
  // generate: 'Generate',
  // regenerate: 'Regenerate',
  // cancel: 'Cancel',
  // next: 'Next',
  // back: 'Back',
  // deployment: 'Deployment',
  // distributionModel: 'Distribution',
  // type: 'Type',
  // pwaAppLabel: 'Progressive Web Apps (Coming Soon)',
  // hybridAppLabel: 'Hybrid Apps',
  // nativeAppLabel: 'Native Apps (Coming Soon)',
  // pwaLabel: 'Progressive Web App (Coming Soon)',
  // hybridLabel: 'Hybrid',
  // nativeLabel: 'Native (Coming Soon)',
  // nativeTxt: 'Native',
  // pwaTxt: 'Progressive Web',
  // showMore: 'show more',
  // showLess: 'show less',
  // comingSoon: '(Coming Soon)',
  // completed: 'COMPLETED',
  // pwaShortDesc: 'Traditional web applications enhanced with',
  // pwaDesc:
  //   'Traditional web applications enhanced with modern web technologies, enabling a more a more app-like experience. Great choice when web is the primary interface for your users (Note: Show only 1 line initiallly and show more shows the full description)',
  // hybridShortDesc: 'Apps with a consistent look-n-feel across web',
  // hybridDesc:
  //   'Apps with a consistent look-n-feel across web and all mobile devices. Easy to build and easy to roll-out, upgrade and maintain',
  // nativeShortDesc: 'Apps built for mobile devices using native',
  // nativeDesc:
  //   'Apps built for mobile devices using native mobile technologies. an excellent choice when user-experience and performance is paramount',
  // enterpriseDesc: 'Application can be deployed through MDM and OTA url',
  // appStoreDesc: 'Application can be deployed to Appstore/Playstore',
  // platform: 'Platform',
  // generationApplication: 'Generating Application',
  // edgeReadyApp: 'Edge Ready Applications',
  // downloadStatusMessage: {
  //   draft: 'App build not initiated',
  //   pending: 'App build not yet Completed',
  //   failed: 'App build failed',
  // },
  // loading: 'Loading',
  // yes: 'Yes',
  // no: 'No',
  // microAppsColumns: [
  //   {
  //     id: 'name',
  //     label: 'Application Name',
  //     align: 'left',
  //     type: 'text',
  //     style: {
  //       marginLeft: 24,
  //       minWidth: '150px',
  //       maxWidth: '150px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '5px',
  //       paddingBottom: '5px',
  //     },
  //   },
  //   {
  //     id: 'checked',
  //     label: '',
  //     align: 'right',
  //     type: 'checkbox_without_icon',
  //     style: {
  //       marginLeft: 24,
  //       minWidth: '50px',
  //       maxWidth: '50px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //     },
  //   },
  // ],
  // copyOtaUrl: 'Copy OTA URL',
  // otaMessage: 'OTA URL Copied to Clipboard',
  // download: 'Download ',
  // app: ' App',
  // downloadSubTitle:
  //   'The application generated available for download, also can be served as a ota url',
  // newMobileApplication: 'Do you want to deploy a new application?',
  // newMobileApplicationSubTitle:
  //   'This enables your end-users to access your new application via the deployment platform of your choice.',
  // buildDetailsTitle: 'Let’s capture some App details',
  // buildDetailsSubTitle:
  //   'This information is required to build your new application',
  // appPermissionsTitle: 'Choose your EdgeReady Applications',
  // appPermissionsSubTitle:
  //   'Enable what your end-users users should see when they login into this new application',
  // masterTablesTitle: 'Master tables',
  // masterTablesSubtitle:
  //   'These table data are built along with the application and can be commonly used across Applications ',
  // advanceOptionsTitle: 'Let’s capture some device permissions',
  // advanceOptionsSubtitle:
  //   'If you are distributing the app via public app stores, then this description will be used by them in the approval process',
  // iOSOptionsTitle: `Let's capture all the Apple related details`,
  // iOSOptionsSubtitle:
  //   'Please upload all the below information as required by Apple for iOS apps',
  // androidOptionsTitle: `Let's capture all the Google related details`,
  // androidOptionsSubtitle:
  //   'Please upload all the below information as required by Google for Android Apps',
  // windowsOptionsTitle: `Let's capture all the Windows related details`,
  // windowsOptionsSubtitle:
  //   'Please upload all the below information as required by Microsoft for Windows Apps',
  // universalWorklistOption:
  //   'Does the app includes universal worklist?(Coming Soon)',
  // advanceOptions: ' - Advanced Options',
  // iosOptions: ' - iOS',
  // androidOptions: ' - Android',
  // windowsOptions: ' - Windows',
  // statusLabels: {
  //   Finished: 'finished',
  //   Draft: 'draft',
  //   Failed: 'failed',
  //   Pending: 'pending',
  // },
  // deviceFeatures: 'Device Features',
  // externalLinks: 'External Links',
  // downloadModalSubTitle: 'You can download the apps here',
  // invalidValue: 'Field is empty',
  // appIconRequired: 'Please upload app icon',
  // packageNameInvalid: "Please enter in this format. i.e: 'com.companyname.appname'",
  // versionNumberInvalid: "starts with '1.0' and above",
  // devicePermissions: ' - Device Permissions',
  // deviceFeatureDefault: { enable: true, description: '' },
  // setnSave: "Save",
  // setnCancel: "Cancel",
  // setnDescription: "Description",
  // setnName: "Name",
  // setnNew: "New",
  // setnTitle: 'Project Settings',
  // setnTitle2: 'Project variables',
  // setnTitle3: 'General',
  // setnNamePlaceholder: 'Project Name',
  // setnDescPlaceholder: 'Description',
  // advancedOptionFields: [
  //   {
  //     name: 'biometric',
  //     id: 'biometric',
  //     label: 'Biometric Authentication',
  //     input: false,
  //     inputPlaceHolder: '',
  //     enable: true,
  //     kind: 'TOUCH',
  //   },
  //   {
  //     name: 'camera',
  //     id: 'camera',
  //     label: 'Camera',
  //     input: true,
  //     inputPlaceHolder:
  //       'Please elaborate why this app needs access to the device camera',
  //     enable: true,
  //     kind: 'CAMERA',
  //   },
  //   {
  //     name: 'gps',
  //     id: 'gps',
  //     label: 'GPS',
  //     input: true,
  //     inputPlaceHolder:
  //       'Please elaborate why this app needs access to the device GPS',
  //     enable: true,
  //     kind: 'PLOCATION',
  //   },
  //   {
  //     name: 'bluetooth',
  //     id: 'bluetooth',
  //     label: 'Bluetooth',
  //     input: true,
  //     inputPlaceHolder:
  //       'Please elaborate why this app needs access to the device bluetooth',
  //     enable: true,
  //     kind: 'BLUETOOTH',
  //   },
  //   {
  //     name: 'contacts',
  //     id: 'contacts',
  //     label: 'Contacts',
  //     input: true,
  //     inputPlaceHolder:
  //       'Please elaborate why this app needs access to the phone contacts',
  //     enable: true,
  //     kind: 'CONTACTS',
  //   },
  // ],
  // externalLinkValue: [
  //   { kind: 'EXTLINK_URL', fileName: '', certificate: '', password: '' },
  // ],
  // buildNumberDefault: {
  //   kind: 'BUILD_NUMBER',
  //   fileName: '',
  //   certificate: '',
  //   password: '',
  // },
  // appIconDefault: { kind: 'A', fileName: '', certificate: '', password: '' },
  // containerAppTable: [
  //   {
  //     id: 'name',
  //     label: 'Name',
  //     align: 'left',
  //     type: 'text',
  //     style: { ...staticStyle, width: '150px' },
  //   },
  //   {
  //     id: 'appType',
  //     label: 'Type',
  //     align: 'left',
  //     type: 'text',
  //     style: { ...staticStyle, width: '80px' },
  //   },
  //   {
  //     id: 'deviceType',
  //     label: 'Platform',
  //     align: 'left',
  //     type: 'dropdown_with_tag',
  //     placeHolder: 'Platform',
  //     dropdownItems: [
  //       { value: 'iOS', label: 'iOS' },
  //       { value: 'Android', label: 'Android' },
  //       { value: 'Windows', label: 'Windows' },
  //     ],
  //     isRowMultiTags: true,
  //     style: { ...staticStyle, width: '100px' },
  //   },
  //   {
  //     id: 'caType',
  //     label: 'Distribution',
  //     align: 'left',
  //     type: 'dropdown',
  //     isMultiSelect: false,
  //     placeHolder: 'Distribution',
  //     dropdownItems: [
  //       { label: 'Enterprise', value: 'enterprise' },
  //       { label: 'Appstore', value: 'appstore' },
  //     ],
  //     style: { ...staticStyle, width: '60px' },
  //   },
  //   {
  //     id: 'version',
  //     label: 'Version/Build',
  //     align: 'left',
  //     type: 'text',
  //     disabled: true,
  //     style: { ...staticStyle, width: '80px' },
  //   },
  //   {
  //     id: 'updateTime',
  //     label: 'Last Updated On',
  //     align: 'left',
  //     type: 'text',
  //     disabled: true,
  //     style: { ...staticStyle, width: '140px', paddingLeft: '100px' },
  //   },
  //   {
  //     id: 'status',
  //     label: 'Status',
  //     align: 'left',
  //     type: 'dropdown',
  //     isMultiSelect: false,
  //     dropdownItems: [
  //       { label: 'Finished', value: 'Finished' },
  //       { label: 'Draft', value: 'draft' },
  //       { label: 'Failed', value: 'failed' },
  //       { label: 'Pending', value: 'pending' },
  //     ],
  //     placeHolder: 'Status',
  //     style: { ...staticStyle, width: '80px' },
  //   },
  //   {
  //     id: 'status',
  //     label: 'statusIcon',
  //     align: 'center',
  //     type: 'icon',
  //     style: { ...staticStyle, width: '40px' },
  //   },
  //   {
  //     id: 'more',
  //     label: '',
  //     align: 'right',
  //     type: 'more',
  //     style: { ...staticStyle, width: '40px' },
  //   },
  // ],
  // masterTablesColumns: [
  //   {
  //     id: 'name',
  //     label: 'Table Name',
  //     align: 'left',
  //     type: 'text',
  //     style: {
  //       marginLeft: 24,
  //       minWidth: '200px',
  //       maxWidth: '200px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //       paddingLeft: '8px',
  //     },
  //   },
  //   {
  //     id: 'filter',
  //     label: 'Data Filters',
  //     align: 'left',
  //     type: 'text_input',
  //     placeholder: "Where (Example: Name='$LOGINID$')",
  //     style: {
  //       minWidth: '400px',
  //       maxWidth: '400px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //     },
  //     inputStyle: {
  //       minWidth: '400x',
  //       maxWidth: '400px',
  //     },
  //   },
  //   {
  //     id: 'checked',
  //     label: '',
  //     align: 'center',
  //     type: 'checkbox_without_icon',
  //     style: {
  //       marginLeft: 24,
  //       minWidth: '50px',
  //       maxWidth: '50px',
  //       overflowWrap: 'break-word',
  //       paddingTop: '8px',
  //       paddingBottom: '8px',
  //     },
  //   },
  // ],
};
export const userTask = {
  bfNotAllowed: 'Project Name should not start with BF_',
  reservedValue: 'Project Name starts with $ is not allowed',
  editSubTitle: 'You can edit all of this information later',
  editVariable: 'Edit Variable',
  newVariable: 'New Variable',
  saveBtn: 'Save',
  cancelBtn: 'Cancel',
  type: 'Type',
  name: 'Name',
  value: 'Value',
  errorAlreadyExist: 'Name already exists',
  errorJson: 'Value should be a JSON format',
  errorNumber: 'Value should be a Number format',
  errorEnterVal: 'Please enter the Value',
  errorEnterName: 'Please enter the Name',
};

export const tenantSessionConstants = {
  // pageTitle: 'Session Settings',
  // sessionSettingTitle: 'Session Settings',
  // tokenValidity: 'Session validity - mins',
  // action: {
  //   cancel: 'Cancel',
  //   save: 'Save',
  // },
};

export const tenantPersonalizationConstants = {
  // pageTitle: 'Password Policy',
  // pageSubTitle: 'Configure how user can choose their password',
  // policyTitle: 'Password Policy',
  // advSettingsTitle: 'Advanced Settings',
  // tokenValidity: 'Session validity - mins',
  // length: 'Enforce minimum password length - characters',
  // uppercaseAllowed: 'Require atleast one uppercase letter from latin alphabet (A-Z)',
  // lowercaseAllowed: 'Require atleast one lowercase letter from latin alphabet (a-z)',
  // numberAllowed: 'Require atleast one number',
  // nonalphaAllowed: "Require atleast one non alphanumeric character ( ! @ # $ % ^ & * ( ) _ + - = [ ] { } | ' )",
  // validity: 'Enable Password expiration',
  // validityInputLabel: 'Expire password - in day(s)',
  // reuse: 'Prevent password reuse',
  // reuseInputLabel: 'Remember - passwords',
  // lockoutThreshold: 'Allowed - failed attempt(s), before an user account locked',
  // lockOutTime: 'Lock the user account for - hour(s)',
  // lockOutWarning: 'Show warning after - failed attempt(s)',
  // emptyField: 'Should not be empty',
};

export const settingsCreateRole = {
  // title: 'Tell us more about this role',
  // subTitle: 'A role defines the responsibilities and job descriptions of people executing a business function.',
  // checkboxLabel: 'Is this role going to build apps or administer the platform?',
};

export const userPropertiesConstants = {
  // title: 'User Settings',
  // newPropertyBtn: 'New Property',
  // userRoleTitle: 'Users and Roles',
  // userRoleSubTitle: 'Manage your roles and what users access your functions.',
  // manageAccessFunc: 'Manage how users access your functions.',
  // manageAccessUser: 'Manage the users who have access to the apps you create.',
  // uarBulkImport: 'Bulk import',
  // uarNew: 'New',
  // uarNewRole: 'New Role',
  // uarBulkUsers: "Bulk import users",
  // uarNewUser: 'New User',
};

export const abapConstants = {
  // titles: {
  //   uploadFlow: {
  //     '-1': {
  //       titleText: 'First, download your SAP objects',
  //       buttonText: { primary: 'Start', secondary: 'Back' },
  //     },
  //     0: {
  //       titleText: 'Upload the ${sapName} (Main Program)',
  //       buttonText: { primary: 'Next', secondary: 'Back' },
  //     },
  //     1: {
  //       titleText: 'Finding dependencies...',
  //       buttonText: { primary: '', secondary: '' },
  //     },
  //     2: {
  //       titleText: 'Upload the Includes',
  //       buttonText: { primary: 'Next', secondary: 'Back' },
  //     },
  //     3: {
  //       titleText: 'Upload Data Dictionary',
  //       buttonText: { primary: 'Next', secondary: 'Back' },
  //     },
  //     4: {
  //       titleText: 'Done!',
  //       buttonText: { primary: '', secondary: "I'll Do it later" },
  //     },
  //   },
  //   optimizeFlow: {
  //     '-1': {
  //       titleText: 'Modernize {appName}',
  //       buttonText: { primary: 'Start', secondary: 'Back' },
  //     },
  //     0: {
  //       titleText: 'First, let’s map this to EdgeReady',
  //       buttonText: { primary: 'Next', secondary: 'Back' },
  //     },
  //     1: {
  //       titleText: 'Application type',
  //       onlApp:
  //         'Online apps need constant network availability and work on all browsers and mobile devices. Easy to deploy and rollout. Excellent when internet connectivity is not a problem for end-users.',
  //       oflApp:
  //         'Offline apps work without any dependency on network availability and only work on mobile devices. They operate in offline mode when internet connectivity is not available and automatically switch to online mode when internet connectivity is established. Excellent for remote location usage where internet connectivity is a problem.',
  //       buttonText: { primary: 'Next', secondary: 'Back' },
  //     },
  //     3: {
  //       titleText: 'Additional Details for your {appName} app',
  //       buttonText: { primary: 'Next', secondary: 'Back' },
  //     },
  //     2: {
  //       titleText: 'Primary deployment platform',
  //       subTitle:
  //         'An app can be deployed on all platforms simultaneously but choosing a particular deployment platform will help you design the app even better for the preferred device of choice by end-users',
  //       web: 'Great choice when web is the only interface for your users.',
  //       mobile:
  //         'Apps with a consistent look-n-feel across all mobile devices and web browsers.',
  //       buttonText: { primary: 'Next', secondary: 'Back' },
  //     },
  //     4: {
  //       titleText: 'Auto mapping...',
  //       buttonText: { primary: '', secondary: '' },
  //     },
  //     5: {
  //       titleText: 'Review mapping',
  //       buttonText: { primary: 'Next', secondary: 'Back' },
  //     },
  //     6: {
  //       titleText: 'Ready to Modernize?',
  //       buttonText: { primary: 'Start', secondary: 'Back' },
  //     },
  //     7: {
  //       titleText: 'Modernizing...',
  //       buttonText: { primary: 'Close', secondary: '' },
  //     },
  //   },
  // },
  // sapObjectTitle: 'SAP Objects selected for modernization',
  // createRoleTitle: 'Tell us more about this role',
  // createRoleSubTitle:
  //   'A role defines the responsibilities and job descriptions of people executing a business function.',
  // isRoleAdminLabel:
  //   'Is this role going to build apps or administer the platform?',
  // uploadMainSubtitle:
  //   "Download the requisite SAP custom objects and load them in the Edge Ready Modernizer. Here's how.",
  // uploadMainGuide: `Need help downloading these? - Check this guide »`,
  // uploadMainFeature1: 'Download Main Program',
  // uploadMainFeature2: 'Download Includes',
  // uploadMainFeature3: 'Download Data Dictionaries',
  // doneSubTitle:
  //   'This object is now ready to start the optimization process. You can do it anytime.',
  // doneSubTitle2: 'Do you want to start now?',
  // startOptimize: 'When you click on “Start”, ',
  // confirmOptimizeSubTitle1:
  //   'you can close this window and continue modernizing other objects.',
  // confirmOptimizeSubTitle2: 'We’ll notify you when it’s done.',
  // loadingText: 'This only takes a minute...',
  // autoMapSuccess: 'Successfully mapped',
  // optimizeMainSubTitle: 'Ready for the future? This is how it works.',
  // optimizeMainFeatureTitle1: 'Automatic mapping',
  // optimizeMainFeatureTitle2: 'Work while you wait',
  // optimizeMainFeatureTitle3: 'Ready for the future',
  // optimizeMainFeatureSubTitle1:
  //   'To save you hours of work, our  engine intelligently maps your objects for you.',
  // optimizeMainFeatureSubTitle2:
  //   'While we modernize your objects, you can continue using EdgeReady.',
  // optimizeMainFeatureSubTitle3:
  //   'When it’s done, your objects will be ready to use on EdgeReady Cloud.',
  // projectDetailInputLabel1:
  //   'Select the role that is going to execute this business function',
  // projectDetailInputLabel2: 'How about the EdgeReady Plugin?',
  // projectDetailInputLabel3: 'To which logical destination?',
  // alreadyUploaded: 'File already uploaded, Action not allowed!',
  // fileError: 'Please select a file to upload',
  // codeError: 'Please provide program to upload',
  // fileSizeLower: 'Size should be greater than 0KB',
  // fileSizeHigher: 'Size should be less than 1MB',
  // fileInvalidFormat: 'Invalid file format',
  // startModernize: 'Modernize',
  // stopModernizeBtn: 'Stop',
  // cancelStopBtn: 'Cancel',
  // modernizeCloserTitle: 'Stop Modernization ?',
  // modernizeCloserSubTitle:
  //   'This will cancel the modernization process and you will have to start from scratch next time.',
  // uploadCloserTitle: 'Stop Upload ?',
  // uploadCloserSubTitle:
  //   'This will cancel the upload process and you will have to start from scratch next time.',
  // closeBtn: "Close",
};

export const projDetailReportConstants = {
  // closeBtn: "Close",
  // attention: "Need(s) Attention",
  // successMap: "Successfully mapped",
  // reports: "Reports",
};

export const tenantConfigConstants = {
  // title: 'Integrations',
  // orgTitle: 'Organization',
  // noContent: 'No Records Available',
  // orgTitle: "Organization",
  // basicInfoTitle: "Basic Information",
  // biName: "Name",
  // biTenantId: "Tenant ID",
  // biDate: "Date format",
  // biLanguage: "Language",
  // biTimezone: "Timezone",
  // biCurrency: "Currency",
  // biSave: "Save",
  // biCancel: "Cancel",
  // errorValid: "Please provide a valid ",
  // errorProvide : "Please provide ",
  // errorSelect: "Please select a ",
  // action: {
  //   new: 'New',
  //   edit: 'Edit',
  //   delete: 'Delete',
  //   download: 'Download',
  //   cancel: 'Cancel',
  //   back: 'Back',
  //   update: 'Update',
  //   save: 'Save',
  //   test: 'Test Connection',
  // },
  // plugin: {
  //   title: 'Plugins',
  //   table: {
  //     name: 'Name',
  //     description: 'Description',
  //     url: 'URL',
  //     checkbox: '',
  //   },
  //   startContainer: {
  //     title: 'Where do you want to start?',
  //     tomcat: {
  //       title: 'Tomcat Server',
  //       subTitle: `Tomcat Server, connects the Apache server and access any exposed Servlet`,
  //       start: 'Start from here',
  //       form: {
  //         label: 'Tell us more about the Plugin',
  //       },
  //     },
  //     sap: {
  //       title: 'SAP  Netweaver',
  //       subTitle: `Helps connecting the SAP system and access the Function Module inside`,
  //       start: 'Start from here',
  //       form: {
  //         label: 'Tell us more about the Plugin',
  //       },
  //     },
  //     abap: {
  //       title: 'SAP ABAP',
  //       subTitle: `Want to import an already existing app ? Use our import tools to start`,
  //       start: 'Start from here',
  //       form: {
  //         label: 'Tell us more about the Plugin',
  //       },
  //     },
  //   },
  //   form: {
  //     title: '',
  //     fields: {
  //       name: {
  //         label: 'Name',
  //         placeHolder: 'Name',
  //         error: {
  //           required: '',
  //         },
  //       },
  //       description: {
  //         label: 'Description',
  //         placeHolder: 'Description',
  //         error: {
  //           required: '',
  //         },
  //       },
  //       url: {
  //         label: 'URL',
  //         placeHolder: 'URL',
  //         error: {
  //           required: '',
  //         },
  //       },
  //       scheme: {
  //         label: 'Scheme',
  //         placeHolder: 'Scheme',
  //         error: {
  //           required: '',
  //         },
  //       },
  //       host: {
  //         label: 'Host',
  //         placeHolder: 'Host',
  //         error: {
  //           required: '',
  //         },
  //       },
  //       port: {
  //         label: 'Port',
  //         placeHolder: 'Port',
  //         error: {
  //           required: '',
  //         },
  //       },
  //       username: {
  //         label: 'Username',
  //         placeHolder: 'Username',
  //         error: {
  //           required: '',
  //         },
  //       },
  //       password: {
  //         label: 'Password',
  //         placeHolder: 'Password',
  //         error: {
  //           required: '',
  //         },
  //       },
  //     },
  //     edit: {
  //       title: 'Tell us more about the Plugin',
  //     },
  //   },
  // },
  // connection: {
  //   title: 'Adapters',
  //   table: {
  //     name: 'Name',
  //     description: 'Description',
  //     pluginName: 'Plugin Name',
  //     type: 'Type',
  //     more: '',
  //   },
  //   form: {
  //     title: 'Tell us more about this Adapter',
  //     fields: {
  //       type: {
  //         label: 'System type',
  //         placeholder: 'Select type',
  //         error: {
  //           required: 'Please provide system type',
  //         },
  //       },
  //       name: {
  //         label: 'Name',
  //         placeholder: 'Name',
  //         error: {
  //           required: 'Please provide name',
  //           maxLength: 'Name should be of max 45 chars',
  //         },
  //       },
  //       plugin: {
  //         label: 'Plugin',
  //         placeholder: 'Select',
  //         error: {
  //           required: 'Please provide Plugin',
  //         },
  //       },
  //       description: {
  //         label: 'Description',
  //         placeholder: 'Description',
  //         error: {
  //           required: 'Please provide Description',
  //         },
  //       },
  //       wsdl: {
  //         label: 'WSDL URI',
  //         placeholder: 'WSDL URI',
  //         error: {
  //           required: 'Please provide WSDL URI',
  //         },
  //       },
  //       host: {
  //         label: 'Host',
  //         placeholder: 'Host',
  //         error: {
  //           required: 'Please provide the Host',
  //         },
  //       },
  //       smtpPort: {
  //         label: 'SMTP Port',
  //         placeholder: 'SMTP Port',
  //         error: {
  //           required: 'Please provide SMTP port',
  //           pattern: 'Please enter valid port number with range from 1-65535',
  //         },
  //       },
  //       userId: {
  //         label: 'User Id',
  //         placeholder: 'User ID',
  //         error: {
  //           required: 'Please provide the userId',
  //         },
  //       },
  //       password: {
  //         label: 'Password',
  //         placeholder: 'Password',
  //         error: {
  //           required: 'Please provide the password',
  //         },
  //       },
  //       sshKey: {
  //         label: 'SSH Key',
  //         placeholder: '',
  //         error: {
  //           required: 'Invalid file format',
  //         },
  //       },
  //       sftpType: {
  //         label: 'Type',
  //         option: {
  //           password: 'Password',
  //           sshkey: 'SSH Key',
  //         },
  //       },
  //       clientId: {
  //         label: 'Client Id',
  //         placeholder: 'Client Id',
  //         error: {
  //           required: 'Please provide the client id',
  //         },
  //       },
  //       clientSecret: {
  //         label: 'Client Secret',
  //         placeholder: 'Client Secret',
  //         error: {
  //           required: 'Please provide the client secret',
  //         },
  //       },
  //       rfcCreds: {
  //         label: 'Use RFC Connection Credentials?',
  //         userServicelabel: 'use Service user?',
  //       },
  //       rfcDestination: {
  //         label: 'RFC Destination',
  //         placeholder: 'RFC Destination',
  //         error: {
  //           required: 'Please provide the RFC Destination',
  //         },
  //       },
  //       endPoint: {
  //         label: 'End Point',
  //         placeholder: 'End Point',
  //         error: {
  //           required: 'Please provide the end point',
  //         },
  //       },
  //       domain: {
  //         label: 'Domain',
  //         placeholder: 'Domain',
  //         error: {
  //           required: 'Please provide the domain',
  //         },
  //       },
  //       uri: {
  //         label: 'URI',
  //         placeholder: 'URI',
  //         error: {
  //           required: 'Please provide the uri',
  //         },
  //       },
  //       method: {
  //         label: 'Method',
  //         placeholder: '',
  //         error: {
  //           required: 'Please provide the method',
  //         },
  //       },
  //       outputType: {
  //         label: 'Output Type',
  //         placeholder: '',
  //         error: {
  //           required: 'Please provide the output type',
  //         },
  //       },
  //       sampleOutput: {
  //         label: 'Sample Output',
  //         placeholder: '',
  //         error: {
  //           required: 'Please provide the sample output',
  //           invalidJson:
  //             'Invalid JSON content, please provide valid JSON format',
  //           invalidXml: 'Invalid XML content, please provide valid XML format',
  //         },
  //       },
  //       email: {
  //         label: 'Email Address',
  //         placeholder: 'Email Address',
  //         error: {
  //           required: 'Please provide the email address',
  //           invalid: 'Invalid email address',
  //         },
  //       },
  //       smtpHost: {
  //         label: 'SMTP Host',
  //         placeholder: 'SMTP Host',
  //         error: {
  //           required: 'Please provide the smtp host',
  //         },
  //       },
  //       userAuth: {
  //         label: 'User Authentication',
  //       },
  //       username: {
  //         label: 'Username',
  //         placeholder: 'Username',
  //         error: {
  //           required: 'Please provide the user name',
  //         },
  //       },
  //       pwdRequired: {
  //         label: `Use DB Connection Credentials? (If Selected, the User will not be
  //           prompted for the DB UserId/Password and Transaction to DB will be
  //           posted using DB Credentials)`,
  //       },
  //       dataSource: {
  //         label: 'Data Source',
  //         placeholder: 'Data Source',
  //         error: {
  //           required: 'Please provide data source',
  //         },
  //       },
  //       dbType: {
  //         label: 'Type',
  //         error: {
  //           required: 'Please provide database type',
  //         },
  //       },
  //     },
  //     edit: {
  //       title: 'Tell us more about this connection',
  //     },
  //   },
  // },
};
export const KEY_PREVIEW_NOTIFICATION = '__er_p_n';

export const offlinePropertySidebar = {
  INTERVAL_OPTIONS_IN_MINUTES: [0, 4, 8, 12, 24],
  VALIDITY_OPTIONS_IN_DAYS: [7, 14, 21, 30],
};

export const DEFAULT_INITIAL_STATE = 'Draft';
export const DEFAULT_END_STATE = 'Completed';

export const operatorTags = {
  GT: '>',
  LT: '<',
  EQ: '=',
  NE: '!=',
  GE: '>=',
  LE: '<=',
};

export const CASE_BLOCK_DEFAULT_VALUE = '*';
export const CASE_BLOCK_DEFAULT_LABEL = 'any';

export const COMPONENT_OPTIONS_KEY = "#__col_ref#"

export const DEFAULT_SCREEN_WITH_MENU = 'data:image/png;base64,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'